import { useTonAddress } from "@tonconnect/ui-react";
import { makePersistable, stopPersisting } from "mobx-persist-store";
import { createContext, ReactNode, useContext, useEffect } from "react";
import { useMemoizedStore } from "../../../stores/common/useMemoizedStore";
import UserCartStore from "../store/UserCartStore";

export const UserCartStoreContext = createContext<UserCartStore | null>(null);

type ProviderProps = {
  children: ReactNode;
};

export const UserCartStoreProvider: React.FC<ProviderProps> = ({
  children,
}) => {
  const userAddress = useTonAddress();
  // const [tonConnectUI] = useTonConnectUI();
  // const tonClientStore = useTonClientStore();
  // let cartStore: UserCartStore | null = null;

  // if (userAddress !== "") {
  //   cartStore = useMemoizedStore(UserCartStore, [userAddress]);
  // }
  let cartStore = useMemoizedStore(UserCartStore, [userAddress]);

  useEffect(() => {
    if (userAddress === "") return;
    makePersistable(cartStore, {
      name: `${userAddress}-UserCartStore`,
      properties: ["cart"],
      storage: window.localStorage,
    });

    return () => {
      stopPersisting(cartStore);
    };
  }, [userAddress]);

  return (
    <UserCartStoreContext.Provider value={cartStore}>
      {children}
    </UserCartStoreContext.Provider>
  );
};

export const useUserCartStore = () => {
  const store = useContext(UserCartStoreContext);

  if (!store) {
    throw new Error(
      "useUserCartStore should be called inside UserCartStoreContext"
    );
  }

  return store;
};
